import { render } from "./ModalStatus.vue?vue&type=template&id=f252acf6"
import script from "./ModalStatus.vue?vue&type=script&lang=js"
export * from "./ModalStatus.vue?vue&type=script&lang=js"

import "./ModalStatus.vue?vue&type=style&index=0&id=f252acf6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__